import { useState, useMemo } from 'react';
import _ from 'lodash';
import { IFlightArrayItem } from './interfaces';
import { defaultFlightArrayItem } from './defaults';

export default function useSelectedData (s_mawb: string) {
    const [selectedFlight, setSelectedFlight] = useState<IFlightArrayItem>(defaultFlightArrayItem);

    // This array is used to calc. storage by being passed into the useStorage hook:
    const filteredFlights = useMemo(() => {
        const { uniqueFlightAwbs } = selectedFlight;
    
        if (uniqueFlightAwbs && uniqueFlightAwbs.length > 0) {
            const newArray = [];
            for (const item of uniqueFlightAwbs) {
                if (item.s_mawb !== s_mawb) {
                    continue;
                }
                const copy = _.cloneDeep(item); 
                copy.selected = true;
                newArray.push(copy); // Add the modified item to the array
            }
            return newArray;
        }
        return [];
    }, [selectedFlight, s_mawb]);
    

    return {
        selectedFlight, 
        setSelectedFlight,
        filteredFlights
    }
}